<template>
  <div v-if="order" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="order">
      <OrderForm
        :order="order"
        :isReadOnly="isReadOnly"
        @update:order="orderLocalUpdate"
        @save="handleSave"
      />

      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :isReadOnly="isReadOnly"
            :model="order"
            modelEditRoute="OrderEditPage"
            modelListRoute="OrdersPage"
            modelRouteParamName="orderNumber"
            :updateCallback="handleUpdateOrder"
            :createCallback="handleCreateOrder"
            :deleteCallback="handleDeleteOrder"
            :fetchPaginatedCallback="fetchOrdersPaginated"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';
import OrderForm from '@/components/Orders/OrderForm.vue';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { ORDERS_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'OrderEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
    OrderForm,
  },
  props: {
    orderNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
    };
  },
  computed: {
    ...mapGetters(['getOrderByNumber', 'getAccessLevel']),
    /** Viewer on the view orders: reads and exports, cannot save or delete. */
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(ORDERS_ACCESS_NODE), 'editor');
    },
    buttons() {
      const isStoredOrder = Boolean(this.order) && this.order.number !== '_new';
      return {
        showDeleteButton: isStoredOrder && !this.isReadOnly,
      };
    },
    order() {
      return this.getOrderByNumber(this.number);
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('orders'), route: { name: 'OrdersPage' } },
        { name: this.order.number !== '_new' ? this.$t('edit') : this.$t('new') },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchOrdersPaginated',
      'fetchOrderByNumber',
      'updateOrder',
      'createOrder',
      'deleteOrder',
      'initOrder',
      'orderLocalUpdate',
    ]),

    async handleSave(order) {
      if (order.number === '_new') {
        await this.handleCreateOrder(order);
      } else {
        await this.handleUpdateOrder(order);
      }
    },

    handleCreateOrder(order) {
      return this.createOrder({ order });
    },

    handleUpdateOrder(order) {
      return this.updateOrder({ order });
    },

    handleDeleteOrder(orderNumber) {
      return this.deleteOrder({ orderNumber });
    },
  },
  async mounted() {
    console.log('OrderEdit:mounted', this.orderNumber);
    if (!this.order && this.orderNumber) {
      this.number = this.orderNumber;
      await this.fetchOrderByNumber({ orderNumber: this.number });
    } else {
      this.initOrder();
      this.number = '_new';
    }
  },
  watch: {
    order(newValue, oldValue) {
      console.log('OrderEdit:order changed', newValue);
    },
  },
};
</script>

<style scoped lang="scss">
.p-calendar {
  width: 100%;
}
</style>
